import { h as _objectWithoutProperties, i as _extends, g as _slicedToArray, c as _asyncToGenerator, d as _regeneratorRuntime } from './_rollupPluginBabelHelpers-e31ab38d.js';
import React, { useState, useEffect } from 'react';
import 'mobx';
import { F as FormattedMessage, t as translate, i as useModal, j as useEscape, k as useStores, f as closeModal, q as useDebounce, a as doFetch } from './FormattedMessage-0747cbce.js';
export { r as config } from './FormattedMessage-0747cbce.js';
import 'react-router-dom';
import { useObserver } from 'mobx-react-lite';
import Loader from 'react-loader-spinner';
export { M as ModalButton } from './ModalButton-db5e7ac0.js';
import { v4 } from 'uuid';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import Tippy from '@tippy.js/react';
import 'tippy.js/dist/tippy.css';

var _excluded = ["required", "htmlFor", "className"];
var Label = function Label(_ref) {
  var _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    htmlFor = _ref.htmlFor,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("label", _extends({
    className: "label ".concat(className),
    htmlFor: htmlFor
  }, rest), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: htmlFor
  }), required && /*#__PURE__*/React.createElement("span", {
    className: "required"
  }, "*"));
};

var _excluded$1 = ["onClick", "text", "icon", "className", "disabled", "values"];
var Button = function Button(_ref) {
  var onClick = _ref.onClick,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    icon = _ref.icon,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? {} : _ref$values,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    executing = _useState2[0],
    setExecuting = _useState2[1];
  var execute = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ev) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            if (!(!disabled && !executing && onClick !== undefined)) {
              _context.next = 6;
              break;
            }
            setExecuting(true);
            _context.next = 5;
            return onClick(ev);
          case 5:
            setExecuting(false);
          case 6:
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            setExecuting(false);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function execute(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return useObserver(function () {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "btn ".concat(className, " ").concat(disabled && 'disabled', " ").concat(icon !== undefined && 'icon-btn'),
      onClick: execute,
      disabled: disabled
    }, rest), icon !== undefined && /*#__PURE__*/React.createElement("i", {
      className: icon,
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement("div", {
      className: "btn-container"
    }, executing && /*#__PURE__*/React.createElement("div", {
      className: "btn-loader"
    }, /*#__PURE__*/React.createElement(Loader, {
      type: "Puff",
      color: "#fff",
      height: 16,
      width: 16,
      style: {
        display: 'flex',
        marginBottom: '5px'
      }
    })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: text,
      values: values
    }))));
  });
};

var Spinner = function Spinner(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 100 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 100 : _ref$height,
    _ref$divHeight = _ref.divHeight,
    divHeight = _ref$divHeight === void 0 ? '200px' : _ref$divHeight;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'center',
      height: divHeight
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    type: "Puff",
    color: "#0f3352",
    height: height,
    width: width
  }));
};

var handler = function handler(props, key, param) {
  var entity = props.entity,
    name = props.name,
    afterChange = props.afterChange,
    validation = props.validation;
  if (name.includes('.')) {
    var keys = name.split('.');
    return keys.reduce(function (obj, child, index) {
      if (index + 1 === keys.length) {
        switch (key) {
          case 'update':
            var oldValue = obj[child];
            obj[child] = param;
            if (afterChange !== undefined) {
              afterChange({
                oldValue: oldValue,
                newValue: param
              });
            }
            break;
          case 'validate':
            try {
              var validationObject = validation === undefined ? entity.validation : validation;
              var errorResult = validationObject[name](param);
              entity["error".concat(name.replace(/\./g, ''))] = errorResult;
              return errorResult;
            } catch (_unused) {
              /* Do not log to prevent spamming the console */
            }
            break;
          case 'getErrorMessage':
            return entity["error".concat(name.replace(/\./g, ''))];
          default:
            return obj[child];
        }
      }
      return obj[child];
    }, entity);
  } else {
    switch (key) {
      case 'update':
        var oldValue = entity[name];
        entity[name] = param;
        if (afterChange !== undefined) {
          afterChange({
            oldValue: oldValue,
            newValue: param
          });
        }
        break;
      case 'getErrorMessage':
        return entity["error".concat(name.replace(/\./g, ''))];
      case 'validate':
        try {
          var validationObject = validation === undefined ? entity.validation : validation;
          var errorResult = validationObject[name](param);
          entity["error".concat(name.replace(/\./g, ''))] = errorResult;
          return errorResult;
        } catch (_unused2) {
          /* Do not log to prevent spamming the console */
        }
        break;
      default:
        return entity[name];
    }
  }
};
var getValue = function getValue(props) {
  var value = handler(props, 'getValue');
  return value;
};
var getErrorMessage = function getErrorMessage(props) {
  return handler(props, 'getErrorMessage');
};
var validate = function validate(props, value) {
  return handler(props, 'validate', value);
};
var setValue = function setValue(props, value) {
  return handler(props, 'update', value);
};

var List = function List(props) {
  var text = props.text,
    value = props.value,
    _props$list = props.list,
    list = _props$list === void 0 ? [] : _props$list,
    _props$disableList = props.disableList,
    disableList = _props$disableList === void 0 ? [] : _props$disableList,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    overwriteWhenNotAvailable = props.overwriteWhenNotAvailable,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? "" : _props$placeholder;
  useEffect(function () {
    var listValues = list.map(function (obj) {
      return obj[value].toString();
    });
    var disabledValues = disableList.map(function (disabledItem) {
      return disabledItem.toString();
    });
    var objectValue = getValue(props);
    objectValue = objectValue !== undefined ? objectValue.toString() : '';
    var availableValues = listValues.filter(function (value) {
      return !disabledValues.includes(value.toString());
    });
    if (!availableValues.includes(objectValue) && availableValues.length > 0 && overwriteWhenNotAvailable || objectValue === undefined || objectValue === '') {
      setValue(props, availableValues[0]);
    }
  });
  var onChange = function onChange(ev) {
    setValue(props, ev.target.value);
    validate(props, ev.target.value);
  };
  var getStatus = function getStatus() {
    var _ref = getErrorMessage(props) || {},
      error = _ref.error,
      message = _ref.message;
    if (error !== undefined && error) {
      return {
        hasError: true,
        placeholder: translate(placeholder),
        message: message
      };
    } else {
      return {
        hasError: error !== undefined && error,
        placeholder: translate(placeholder),
        message: message
      };
    }
  };
  return useObserver(function () {
    var _getStatus = getStatus(),
      hasError = _getStatus.hasError,
      message = _getStatus.message;
    var options = list.map(function (item) {
      var textToDisplay = item[text];
      if (text === 'translation' && item.translation !== undefined) {
        textToDisplay = item.translation;
      }
      if (text === 'translation' && item.text !== undefined) {
        textToDisplay = item.text;
      }
      if (text === 'translation' && item.name !== undefined) {
        textToDisplay = item.name;
      }
      if (text.includes('.')) {
        textToDisplay = text.split('.').reduce(function (obj, param) {
          return obj[param];
        }, item);
      }
      var displayText = text === 'translation' && textToDisplay !== null && textToDisplay !== '' && textToDisplay !== undefined ? translate(textToDisplay) : textToDisplay;
      return /*#__PURE__*/React.createElement("option", {
        key: item[value],
        value: item[value],
        disabled: disableList.includes(item[value]) || disabled
      }, displayText);
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", {
      className: "select ".concat(className),
      value: getValue(props),
      onChange: onChange,
      disabled: disabled
    }, options), hasError && /*#__PURE__*/React.createElement("div", {
      className: "inputError"
    }, /*#__PURE__*/React.createElement("span", {
      className: "errorMessage"
    }, message)));
  });
};

var _excluded$2 = ["placeholder", "type", "className", "disableAutoFill", "maxLength", "infinityValue", "disableErrorText"];
var Input = function Input(props) {
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$disableAutoFil = props.disableAutoFill,
    disableAutoFill = _props$disableAutoFil === void 0 ? false : _props$disableAutoFil,
    maxLength = props.maxLength,
    _props$infinityValue = props.infinityValue,
    infinityValue = _props$infinityValue === void 0 ? 2147483647 : _props$infinityValue,
    _props$disableErrorTe = props.disableErrorText,
    disableErrorText = _props$disableErrorTe === void 0 ? false : _props$disableErrorTe,
    rest = _objectWithoutProperties(props, _excluded$2);
  var onChange = function onChange(ev) {
    setValue(props, ev.target.value);
  };
  var onValidate = function onValidate(ev) {
    if (ev.target.value !== '') {
      validate(props, ev.target.value);
    }
  };
  var getStatus = function getStatus() {
    var _ref = getErrorMessage(props) || {},
      error = _ref.error,
      message = _ref.message;
    if (error !== undefined && error) {
      return {
        hasError: true,
        placeholder: translate(placeholder),
        message: message
      };
    } else {
      return {
        hasError: error !== undefined && error,
        placeholder: translate(placeholder),
        message: message
      };
    }
  };
  return useObserver(function () {
    var _getStatus = getStatus(),
      hasError = _getStatus.hasError,
      placeholder = _getStatus.placeholder,
      message = _getStatus.message;
    var value = getValue(props);
    if (value == infinityValue) {
      value = '∞';
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "input"
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: "".concat(className, " ").concat(hasError && 'invalid', " ").concat(maxLength !== undefined && 'maxLengthInput'),
      type: type,
      onChange: onChange,
      value: value,
      onBlur: onValidate,
      placeholder: placeholder,
      autoComplete: disableAutoFill ? 'none' : undefined
    }, rest)), maxLength !== undefined && /*#__PURE__*/React.createElement("span", {
      className: "maxLength"
    }, value.length, "/", maxLength)), !disableErrorText && hasError && /*#__PURE__*/React.createElement("div", {
      className: "inputError"
    }, /*#__PURE__*/React.createElement("span", {
      className: "errorMessage"
    }, message)));
  });
};

var styles = "";

var Error = function Error(_ref) {
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? '' : _ref$error,
    _ref$activeErrors = _ref.activeErrors,
    activeErrors = _ref$activeErrors === void 0 ? [] : _ref$activeErrors;
  return useObserver(function () {
    if (error !== '' || activeErrors.length) {
      return /*#__PURE__*/React.createElement("section", {
        className: styles.errorInfo
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.errorTitle
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "please_resolve_the_following_errors"
      })), /*#__PURE__*/React.createElement("ul", null, error !== '' && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: error
      })), activeErrors.map(function (error, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: error.message
        }));
      })));
    }
    return null;
  });
};

var Modal = function Modal(_ref) {
  var id = _ref.id,
    className = _ref.className,
    children = _ref.children,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    _ref$disableFooter = _ref.disableFooter,
    disableFooter = _ref$disableFooter === void 0 ? false : _ref$disableFooter,
    onEnter = _ref.onEnter;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useModal = useModal(),
    register = _useModal.register,
    unregister = _useModal.unregister;
  var _useStores = useStores(),
    modalStore = _useStores.modalStore;
  var close = function close() {
    closeModal(id);
  };
  useEscape(function () {
    closeModal(id);
  });
  useEffect(function () {
    if (isOpen && onOpen !== undefined) {
      onOpen();
    }
    if (!isOpen && onClose !== undefined) {
      onClose();
    }
  }, [isOpen]);
  useEffect(function () {
    if (isOpen) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else if (!isOpen) {
      document.getElementsByTagName('body')[0].style.overflow = 'auto';
    }
  }, [isOpen]);
  useEffect(function () {
    register(id, setIsOpen);
    return function () {
      unregister(id);
    };
  }, []);
  var onKeyDown = function onKeyDown(ev) {
    if (ev.key === 'Enter' && onEnter) {
      onEnter();
    }
  };
  return useObserver(function () {
    var activeModals = modalStore.activeModals;
    var displayOverlay = activeModals.length > 0 && activeModals[0].id === id;
    return isOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      id: id,
      onKeyDown: onKeyDown,
      className: "modal ".concat(className, " ").concat(disableFooter ? 'dpt-modal-without-footer' : 'dpt-modal-with-footer')
    }, children), displayOverlay && /*#__PURE__*/React.createElement("div", {
      className: "modal-overlay",
      onClick: close,
      style: {
        zIndex: id === 'warningModal' ? 15004 : 5000
      }
    }));
  });
};

var _excluded$3 = ["placeholder", "className", "disableAutoFill", "maxLength", "infinityValue"];
var PasswordInput = function PasswordInput(props) {
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$disableAutoFil = props.disableAutoFill,
    disableAutoFill = _props$disableAutoFil === void 0 ? false : _props$disableAutoFil,
    maxLength = props.maxLength,
    _props$infinityValue = props.infinityValue,
    infinityValue = _props$infinityValue === void 0 ? 2147483647 : _props$infinityValue,
    rest = _objectWithoutProperties(props, _excluded$3);
  var _useState = useState('password'),
    _useState2 = _slicedToArray(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  var onChange = function onChange(ev) {
    setValue(props, ev.target.value);
  };
  var onValidate = function onValidate(ev) {
    validate(props, ev.target.value);
  };
  var getStatus = function getStatus() {
    var _ref = getErrorMessage(props) || {},
      error = _ref.error,
      message = _ref.message;
    if (error !== undefined && error) {
      return {
        hasError: true,
        placeholder: translate(placeholder),
        message: message
      };
    } else {
      return {
        hasError: error !== undefined && error,
        placeholder: translate(placeholder),
        message: message
      };
    }
  };
  return useObserver(function () {
    var _getStatus = getStatus(),
      hasError = _getStatus.hasError,
      placeholder = _getStatus.placeholder,
      message = _getStatus.message;
    var value = getValue(props);
    if (value == infinityValue) {
      value = '∞';
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "passwordInput"
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: "".concat(className, " ").concat(hasError && 'invalid', " ").concat(maxLength !== undefined && 'maxLengthInput'),
      type: type,
      onChange: onChange,
      value: value,
      onBlur: onValidate,
      placeholder: placeholder,
      autoComplete: disableAutoFill ? 'none' : undefined
    }, rest)), maxLength !== undefined && /*#__PURE__*/React.createElement("span", {
      className: "maxLength"
    }, value.length, "/", maxLength), /*#__PURE__*/React.createElement("div", {
      className: "passwordBtn",
      onClick: function onClick() {
        setType(type === 'text' ? 'password' : 'text');
        console.log(type);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-eye",
      "aria-hidden": "true"
    })))), hasError && /*#__PURE__*/React.createElement("div", {
      className: "inputError"
    }, /*#__PURE__*/React.createElement("span", {
      className: "errorMessage"
    }, message)));
  });
};

var Dropdown = function Dropdown(_ref) {
  var _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'fa fa-chevron-down' : _ref$icon,
    text = _ref.text,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$leftIcon = _ref.leftIcon,
    leftIcon = _ref$leftIcon === void 0 ? '' : _ref$leftIcon,
    _ref$disableIcon = _ref.disableIcon,
    disableIcon = _ref$disableIcon === void 0 ? false : _ref$disableIcon;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var toggleState = function toggleState(ev) {
    ev.stopPropagation();
    setState(!state);
  };
  var close = function close(ev) {
    ev.stopPropagation();
    setState(false);
  };
  return useObserver(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "dpt-dropdown-container ".concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "dpt-dropdown",
      onClick: toggleState
    }, !disableIcon && leftIcon !== '' && /*#__PURE__*/React.createElement("i", {
      className: "dpt-dropdown-left-icon ".concat(leftIcon)
    }), /*#__PURE__*/React.createElement(FormattedMessage, {
      id: text
    }), !disableIcon && /*#__PURE__*/React.createElement("i", {
      className: icon
    })), state && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
      className: "dpt-dropdown-list",
      onClick: close
    }, children), /*#__PURE__*/React.createElement("div", {
      className: "dpt-dropdown-overlay",
      onClick: close
    })));
  });
};

var _excluded$4 = ["placeholder", "type", "className", "pickerType"];
dayjs.extend(customParseFormat);
var TimeInput = function TimeInput(props) {
  var randomId = v4();
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$pickerType = props.pickerType,
    pickerType = _props$pickerType === void 0 ? 'time' : _props$pickerType,
    rest = _objectWithoutProperties(props, _excluded$4);
  useEffect(function () {
    var value = getValue(props);
    var element = document.getElementById(randomId);
    var timeConfig = {
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      defaultDate: value,
      onChange: function onChange(ev) {
        setValue(props, dayjs(ev[0]).format('HH:mm'));
      }
    };
    var dateConfig = {
      enableTime: false,
      disableMobile: true,
      time_24hr: true,
      allowInput: true,
      dateFormat: "d/m/Y",
      defaultDate: value,
      onChange: function onChange(ev) {
        setValue(props, dayjs(ev[0]).format('DD/MM/YYYY'));
      }
    };
    var multiConfig = {
      enableTime: true,
      disableMobile: true,
      time_24hr: true,
      allowInput: true,
      dateFormat: "d/m/Y H:i",
      defaultDate: value,
      onChange: function onChange(ev) {
        setValue(props, dayjs(ev[0]).format('DD/MM/YYYY HH:mm'));
      }
    };
    switch (pickerType) {
      case 'multi':
        flatpickr(element, multiConfig);
        break;
      case 'date':
        flatpickr(element, dateConfig);
        break;
      default:
        flatpickr(element, timeConfig);
    }
  }, []);
  var onChange = function onChange(ev) {
    setValue(props, ev.target.value);
  };
  var onValidate = function onValidate(ev) {
    validate(props, ev.target.value);
  };
  var getStatus = function getStatus() {
    var _ref = getErrorMessage(props) || {},
      error = _ref.error,
      message = _ref.message;
    if (error !== undefined && error) {
      return {
        hasError: true,
        placeholder: translate(message)
      };
    } else {
      return {
        hasError: error !== undefined && error,
        placeholder: placeholder !== '' ? translate(placeholder) : ''
      };
    }
  };
  return useObserver(function () {
    var _getStatus = getStatus(),
      hasError = _getStatus.hasError,
      placeholder = _getStatus.placeholder;
    var value = getValue(props);
    return /*#__PURE__*/React.createElement("input", _extends({
      id: randomId,
      className: "".concat(className, " ").concat(hasError && 'invalid'),
      type: type,
      onChange: onChange,
      value: value,
      onBlur: onValidate,
      placeholder: placeholder,
      autoComplete: "off"
    }, rest));
  });
};

var _excluded$5 = ["placeholder", "type", "className", "disableAutoFill", "maxLength"];
var TextArea = function TextArea(props) {
  var _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$disableAutoFil = props.disableAutoFill,
    disableAutoFill = _props$disableAutoFil === void 0 ? false : _props$disableAutoFil,
    maxLength = props.maxLength,
    rest = _objectWithoutProperties(props, _excluded$5);
  var onChange = function onChange(ev) {
    setValue(props, ev.target.value);
  };
  var onValidate = function onValidate(ev) {
    validate(props, ev.target.value);
  };
  var getStatus = function getStatus() {
    var _ref = getErrorMessage(props) || {},
      error = _ref.error,
      message = _ref.message;
    if (error !== undefined && error) {
      return {
        hasError: true,
        placeholder: translate(placeholder),
        message: message
      };
    } else {
      return {
        hasError: error !== undefined && error,
        placeholder: translate(placeholder),
        message: message
      };
    }
  };
  return useObserver(function () {
    var _getStatus = getStatus(),
      hasError = _getStatus.hasError,
      placeholder = _getStatus.placeholder,
      message = _getStatus.message;
    var value = getValue(props);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "input"
    }, /*#__PURE__*/React.createElement("textarea", _extends({
      className: "".concat(className, " ").concat(hasError && 'invalid', " maxLengthInput"),
      type: type,
      onChange: onChange,
      value: value,
      onBlur: onValidate,
      placeholder: placeholder,
      autoComplete: disableAutoFill ? 'none' : undefined
    }, rest)), maxLength !== undefined && /*#__PURE__*/React.createElement("span", {
      className: "maxLength"
    }, value.length, "/", maxLength)), hasError && /*#__PURE__*/React.createElement("div", {
      className: "inputError"
    }, /*#__PURE__*/React.createElement("span", {
      className: "errorMessage"
    }, message)));
  });
};

var SecondsInput = function SecondsInput(props) {
  var enableInifnite = props.enableInifnite;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    hours = _useState2[0],
    setHours = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    minutes = _useState4[0],
    setMinutes = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    seconds = _useState6[0],
    setSeconds = _useState6[1];
  var formatSeconds = function formatSeconds(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor(seconds % 3600 / 60);
    return [hours, minutes, Math.floor(seconds % 60)];
  };
  var getSeconds = function getSeconds(hours, minutes, seconds) {
    return parseInt(seconds) + parseInt(minutes * 60) + parseInt(hours * 60 * 60);
  };
  useEffect(function () {
    var objectValue = getValue(props);
    var _formatSeconds = formatSeconds(objectValue),
      _formatSeconds2 = _slicedToArray(_formatSeconds, 3),
      hours = _formatSeconds2[0],
      minutes = _formatSeconds2[1],
      seconds = _formatSeconds2[2];
    setHours(hours);
    setMinutes(minutes);
    setSeconds(seconds);
  }, []);
  var updateHours = function updateHours(ev) {
    setHours(ev.target.value);
    setValue(props, getSeconds(ev.target.value, minutes, seconds));
  };
  var updateMinutes = function updateMinutes(ev) {
    setMinutes(ev.target.value);
    setValue(props, getSeconds(hours, ev.target.value, seconds));
  };
  var updateSeconds = function updateSeconds(ev) {
    setSeconds(ev.target.value);
    setValue(props, getSeconds(hours, minutes, ev.target.value));
  };
  var onChange = function onChange(ev) {
    setHours(0);
    setSeconds(0);
    setMinutes(0);
    if (ev.target.checked) {
      setValue(props, 2147483647);
    } else {
      setValue(props, 0);
    }
  };
  return useObserver(function () {
    var value = getValue(props);
    return /*#__PURE__*/React.createElement(React.Fragment, null, enableInifnite && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      onChange: onChange,
      checked: parseInt(value) === 2147483647
    }), /*#__PURE__*/React.createElement("span", {
      className: "checkbox"
    }, "Infinite"))), parseInt(value) !== 2147483647 && /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gridGap: '10px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "timeinput"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      name: "",
      min: 0,
      value: hours,
      onChange: updateHours
    }), /*#__PURE__*/React.createElement("span", null, "h")), /*#__PURE__*/React.createElement("div", {
      className: "timeinput"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      name: "",
      min: 0,
      value: minutes,
      onChange: updateMinutes
    }), /*#__PURE__*/React.createElement("span", null, "m")), /*#__PURE__*/React.createElement("div", {
      className: "timeinput"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      name: "",
      min: 0,
      value: seconds,
      onChange: updateSeconds
    }), /*#__PURE__*/React.createElement("span", null, "s"))));
  });
};

var Checkbox = function Checkbox(props) {
  var handler = props.handler,
    checked = props.checked;
  var onChange = function onChange(ev) {
    if (handler) {
      handler(ev.target.checked);
    } else {
      setValue(props, ev.target.checked);
    }
  };
  return useObserver(function () {
    var value = checked !== undefined ? checked : getValue(props);
    return /*#__PURE__*/React.createElement("div", {
      className: "dpt-checkbox"
    }, /*#__PURE__*/React.createElement("label", {
      className: "checkbox-container"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      onChange: onChange,
      checked: value
    }), /*#__PURE__*/React.createElement("span", {
      className: "checkmark"
    })));
  });
};

var InfiniteList = function InfiniteList() {
  return useObserver(function () {
    return /*#__PURE__*/React.createElement("div", null, "infinite List");
  });
};

var _excluded$6 = ["tooltip", "tooltipValues", "placeholder", "type", "disableAutoFill", "disableErrorText", "className"];
var InfoInput = function InfoInput(props) {
  var tooltip = props.tooltip,
    _props$tooltipValues = props.tooltipValues,
    tooltipValues = _props$tooltipValues === void 0 ? {} : _props$tooltipValues,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    _props$disableAutoFil = props.disableAutoFill,
    disableAutoFill = _props$disableAutoFil === void 0 ? false : _props$disableAutoFil,
    _props$disableErrorTe = props.disableErrorText,
    disableErrorText = _props$disableErrorTe === void 0 ? false : _props$disableErrorTe,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    rest = _objectWithoutProperties(props, _excluded$6);
  var onChange = function onChange(ev) {
    setValue(props, ev.target.value);
  };
  var onValidate = function onValidate(ev) {
    validate(props, ev.target.value);
  };
  var getStatus = function getStatus() {
    var _ref = getErrorMessage(props) || {},
      message = _ref.message,
      error = _ref.error;
    if (error !== undefined && error) {
      return {
        placeholder: message,
        hasError: true,
        message: message
      };
    } else {
      return {
        placeholder: placeholder !== '' ? translate(placeholder) : placeholder,
        hasError: false,
        message: message
      };
    }
  };
  return useObserver(function () {
    var _getStatus = getStatus(),
      hasError = _getStatus.hasError,
      placeholder = _getStatus.placeholder,
      message = _getStatus.message;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "infoInput"
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: "".concat(className, " ").concat(hasError && 'invalid'),
      type: type,
      autoComplete: disableAutoFill && 'none',
      onChange: onChange,
      value: getValue(props),
      onBlur: onValidate,
      placeholder: placeholder
    }, rest)), /*#__PURE__*/React.createElement(Tippy, {
      content: tooltip !== '' ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: translate(tooltip, tooltipValues)
        }
      }) : '',
      arrow: true,
      duration: 500,
      delay: [100, 50],
      placement: "bottom-end",
      interactive: true,
      trigger: "mouseenter focus click manual"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-info-circle tooltipped tooltipIcon",
      "data-position": "left",
      "data-tooltip": tooltip,
      tabIndex: "-1"
    }))), !disableErrorText && hasError && /*#__PURE__*/React.createElement("div", {
      className: "inputError"
    }, /*#__PURE__*/React.createElement("span", {
      className: "errorMessage"
    }, message)));
  });
};

var SearchSelect = function SearchSelect(props) {
  var getByIdUrl = props.getByIdUrl,
    paginatedUrl = props.paginatedUrl,
    text = props.text,
    value = props.value,
    inputStyle = props.inputStyle,
    _props$setObject = props.setObject,
    setObject = _props$setObject === void 0 ? false : _props$setObject,
    _props$valuesToIgnore = props.valuesToIgnore,
    valuesToIgnore = _props$valuesToIgnore === void 0 ? [] : _props$valuesToIgnore,
    _props$filter = props.filter,
    filter = _props$filter === void 0 ? '' : _props$filter,
    entity = props.entity;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    input = _useState2[0],
    setInput = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    items = _useState4[0],
    setItems = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var objectValue = getValue(props);
  useEffect(function () {
    var getObject = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return doFetch("".concat(URL).concat(getByIdUrl, "/").concat(objectValue));
            case 2:
              result = _context.sent;
              setDisplayText(result);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getObject() {
        return _ref.apply(this, arguments);
      };
    }();
    if (objectValue && objectValue !== '') {
      getObject();
    }
  }, []);
  useEffect(function () {
    if (objectValue === '' && input !== '') {
      setInput('');
      setItems([]);
    }
  }, [objectValue]);
  useDebounce(function () {
    var fetchItems = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var objToSort, _yield$doFetch, data, values;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(input !== '')) {
                _context2.next = 8;
                break;
              }
              objToSort = {
                count: 100,
                pagenumber: 1,
                filters: [],
                sortrules: [],
                searchString: input
              };
              _context2.next = 4;
              return doFetch(paginatedUrl, 'POST', objToSort);
            case 4:
              _yield$doFetch = _context2.sent;
              data = _yield$doFetch.data;
              values = data.map(function (item) {
                return item[value];
              });
              if (data.length > 0 && !values.includes(objectValue)) {
                if (valuesToIgnore !== undefined) {
                  setItems(data.filter(function (data) {
                    return !valuesToIgnore.includes(data[filter]);
                  }));
                } else {
                  setItems(data);
                }
              } else {
                setItems([]);
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function fetchItems() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (!loading) {
      if (input !== '' && objectValue !== '00000000-0000-0000-0000-000000000000' && objectValue !== '') {
        fetchItems();
      }
    } else {
      setLoading(false);
    }
  }, [paginatedUrl, input]);
  var getDisplayText = function getDisplayText(obj) {
    if (Array.isArray(text)) {
      return text.reduce(function (name, key) {
        return name += "".concat(obj[key], " ");
      }, '');
    } else {
      return obj[text];
    }
  };
  var setDisplayText = function setDisplayText(obj) {
    if (Array.isArray(text)) {
      var result = text.reduce(function (name, key) {
        return name += "".concat(obj[key], " ");
      }, '');
      setInput(result);
    } else {
      setInput(obj[text]);
    }
  };
  var changeInput = function changeInput(ev) {
    var value = ev.target.value;
    setInput(value);
    setValue(props, value);
    validate(props, value);
    if (value === '') {
      setItems([]);
    }
  };
  var selectValue = function selectValue(obj) {
    setValue(props, setObject ? obj : obj[value]);
    setInput(getDisplayText(obj));
    validate(props, value);
  };
  return useObserver(function () {
    var _ref3 = getErrorMessage(props) || {},
      error = _ref3.error;
    return /*#__PURE__*/React.createElement("div", {
      className: "dpt-searchable-select"
    }, /*#__PURE__*/React.createElement("input", {
      className: "select ".concat(error !== undefined && error && 'invalid'),
      type: "text",
      value: input,
      onChange: changeInput,
      style: inputStyle,
      placeholder: "Type to search..."
    }), !(items.length === 1 && getDisplayText(items[0]) === input) && /*#__PURE__*/React.createElement("ul", {
      className: "dpt-searchable-select-list"
    }, items.map(function (item) {
      return /*#__PURE__*/React.createElement("li", {
        onClick: function onClick() {
          return selectValue(item);
        }
      }, getDisplayText(item));
    })));
  });
};

var Switch = function Switch(props) {
  var _props$onlabel = props.onlabel,
    onlabel = _props$onlabel === void 0 ? 'yes' : _props$onlabel,
    _props$offlabel = props.offlabel,
    offlabel = _props$offlabel === void 0 ? 'no' : _props$offlabel,
    _props$labelsDisabled = props.labelsDisabled,
    labelsDisabled = _props$labelsDisabled === void 0 ? false : _props$labelsDisabled,
    checked = props.checked,
    handler = props.handler;
  var onChange = function onChange(ev) {
    if (handler) {
      handler(ev.target.checked);
    } else {
      setValue(props, ev.target.checked);
    }
  };
  return useObserver(function () {
    var value = checked !== undefined ? checked : getValue(props);
    return /*#__PURE__*/React.createElement("div", {
      className: "dpt-switch-container"
    }, !labelsDisabled && /*#__PURE__*/React.createElement(Label, {
      htmlFor: offlabel
    }), /*#__PURE__*/React.createElement("div", {
      className: "switch",
      onClick: function onClick() {
        return setValue(props, !value);
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: value,
      onChange: onChange
    }), /*#__PURE__*/React.createElement("span", {
      className: "slider round"
    })), !labelsDisabled && /*#__PURE__*/React.createElement(Label, {
      htmlFor: onlabel
    }));
  });
};

var Info = function Info(_ref) {
  var info = _ref.info;
  return /*#__PURE__*/React.createElement("div", {
    className: "info-page"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: info
  }));
};

export { Button, Checkbox, Dropdown, Error, InfiniteList, Info, Input, InfoInput as InputToolTip, Label, List, Modal, PasswordInput, SearchSelect as SearchableSelect, SecondsInput, Spinner, Switch, TextArea, TimeInput };
